import { PatientIdIdentifier } from "./PatientIdIdentifier";
import { SerialIdentifier } from "./SerialIdentifier";

export class UserIdentity {
  public serialIdentifier: SerialIdentifier;
  public patientIdIdentifier: PatientIdIdentifier;
  public sourceIdType: string;

  public constructor(
    serialNumber: string,
    patientId: string,
    sourceIdType: string
  ) {
    this.sourceIdType = sourceIdType;
    this.patientIdIdentifier = new PatientIdIdentifier(patientId);

    if (serialNumber){
      this.serialIdentifier = new SerialIdentifier(serialNumber);
    }
  }

  /**
   * Generates the source ID field for the response in one of the two formats:
   * PATIENT_ID#{patientId} - if sourceIdType is "patient-id"
   * DEVICE_SERIAL#{deviceSerial} - if sourceIdType is "device-serial" or null
   */
  generateSourceId(): string {
    if (this.sourceIdType === "patient-id" || !this.serialIdentifier) {
      return this.patientIdIdentifier.generateSourceId();
    }

    return this.serialIdentifier.generateSourceId();
  }

  toString(): string {
    let identity = `Patient ID: ${this.patientIdIdentifier.patientId}`;

    if (this.serialIdentifier) {
      identity += ` Serial: ${this.serialIdentifier.serialNumber};`;
    }

    return identity;
  }
}
